var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5367 6.0546L0.4697 9.4686C0.3817 9.7466 0.5357 10.0446 0.8147 10.1326C0.9447 10.1736 1.0847 10.1626 1.2067 10.1026L10.0967 5.7986C10.3487 5.6756 10.4527 5.3726 10.3297 5.1216C10.2807 5.0196 10.1987 4.9386 10.0967 4.8886L1.2127 0.580602C0.9497 0.452602 0.6337 0.560602 0.5047 0.823602C0.4457 0.945602 0.4347 1.0856 0.4757 1.2156L1.5437 4.6296L5.5927 5.0226C5.7677 5.0396 5.8967 5.1966 5.8787 5.3716C5.8637 5.5236 5.7437 5.6436 5.5927 5.6586L1.5367 6.0546Z",
    fill: "#D4DFE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/add-comment.0d3a936d4842004acf03766099ed8854.svg";
export { ForwardRef as ReactComponent };